import type { DragIntent } from "../game/cards/types";

export type BotId = "off" | "hold-will" | "learner" | "random";

export type BotAction =
  | { type: "proclaim"; instanceId: string; intent: DragIntent | null; reason: string }
  | { type: "reveal"; instanceId: string; reason: string }
  | { type: "recall"; reason: string }
  | { type: "wait"; reason: string };

export const BOT_LABELS: Record<BotId, string> = {
  off: "Off (you play)",
  "hold-will": "Hold Will (good)",
  learner: "Learner (new player)",
  random: "Random",
};
